import React, { ReactElement, ReactNode } from 'react';
import { Box, HStack, Label, InfoBadge } from '@medely/ui-kit';

type JobDetailsListItemProps = {
  children?: ReactNode;
  icon?: ReactElement;
  title?: string;
  titleNode?: ReactNode;
  small?: boolean;
  showRequiredBadge?: boolean;
};

const TitleComponent = ({
  title,
  showRequiredBadge,
  small,
}: Pick<JobDetailsListItemProps, 'title' | 'showRequiredBadge' | 'small'>) => (
  <HStack gap={2} alignItems="center">
    <Label size={small ? 'm' : 'l'}>{title}</Label>
    {showRequiredBadge && (
      <Box>
        <InfoBadge label="Required" color="info" testId="specialty-required-badge" />
      </Box>
    )}
  </HStack>
);

export const JobDetailsListItem = ({
  children,
  icon,
  title,
  titleNode,
  small,
  showRequiredBadge = false,
}: JobDetailsListItemProps): ReactElement => {
  return (
    <HStack testId="job-details-list-item">
      <Box pr={icon ? 2 : 0}>{icon}</Box>
      <Box flex={1}>
        {titleNode ??
          (title ? (
            <TitleComponent title={title} showRequiredBadge={showRequiredBadge} small={small} />
          ) : null)}
        {children}
      </Box>
    </HStack>
  );
};
